import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-bold-trash',
    imports: [],
    templateUrl: './icon-bold-trash.html',
    styleUrl: './icon-bold-trash.css'
})
export class IconBoldTrash {
    @Input() color: string = 'currentColor';
    @Input() size: string = '24px';
}
